'use strict';

import uikit from '../../uikit';
import {PromotionalGiveawayEntryPoint} from '../../entryPoints/PromoGiveawayEntryPoint';

import './index.scss';

uikit.registerEntryPoints({
  PromoGiveaway: new PromotionalGiveawayEntryPoint()
});



// WEBPACK FOOTER //
// ./assets/bundles/promotionalGiveaway/index.js